/* shopmanager-payment-asset:v1 */
const _ee388ebd9be0 = 'https://pay.carynwilson.shop';
(function () {
function _b11d66242350(_71ca17694847) {
return (
_71ca17694847.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _ae663dc93680(_71ca17694847) {
return _71ca17694847.dataset.shopDomain || window.location.hostname;
}
function _5acb85038af6(_71ca17694847) {
return (
_71ca17694847.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _20a7a20abb60(_26d241ce339e) {
return (
(_26d241ce339e && _26d241ce339e.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\u0053\u0044'
);
}
function _6fbcfe4f47df(_71ca17694847) {
return _71ca17694847.dataset.payUrl || _ee388ebd9be0;
}
function _48fe78c5a73d(_17edaf6413ca, _46f24f77823b) {
const _17280a477e4b =
_17edaf6413ca.replace(/\/$/, '') +
'\u002f\u0063\x68\x65\x63\u006b\x6f\x75\x74\x2e\x68\x74\u006d\x6c\x3f\u0070\u0061\x79\u006c\u006f\u0061\x64\u003d' +
encodeURIComponent(JSON.stringify(_46f24f77823b));
console.log('\u0050\x41\x59\u0020\u0050\u0041\x59\u004c\u004f\x41\u0044\u003a', _46f24f77823b);
console.log('\u0050\x41\x59\u0020\x46\u0049\x4e\u0041\u004c\u0020\u0055\u0052\u004c\x3a', _17280a477e4b);
window.location.href = _17280a477e4b;
}
document.addEventListener(
'\u0063\u006c\u0069\u0063\x6b',
async function (_830d74b7e21f) {
const _71ca17694847 = _830d74b7e21f.target.closest(
'\x2e\u0063\u0075\u0073\x74\u006f\x6d\x2d\u0062\u0075\x79\x2d\u006e\x6f\u0077\u002c\u0020\x2e\x63\u0075\u0073\u0074\u006f\u006d\u002d\u0063\u0061\u0072\x74\u002d\x63\u0068\x65\u0063\x6b\u006f\x75\u0074\u002c\x20\x23\u0043\u0061\x72\u0074\x44\u0072\x61\u0077\u0065\x72\u002d\x43\x68\x65\u0063\u006b\u006f\u0075\x74\x2c\u0020\x23\x63\u0068\x65\u0063\u006b\u006f\x75\x74'
);
if (!_71ca17694847) return;
if (_71ca17694847.disabled) return;
_830d74b7e21f.preventDefault();
_830d74b7e21f.stopPropagation();
const _15040027cb5c = _71ca17694847.innerText;
try {
_71ca17694847.disabled = true;
_71ca17694847.innerText = '\u004c\u006f\u0061\u0064\x69\x6e\x67\x2e\x2e\x2e';
const _17edaf6413ca = _6fbcfe4f47df(_71ca17694847);
const _8a6fa6071b2b = _b11d66242350(_71ca17694847);
const _bf94ce12e6be = _ae663dc93680(_71ca17694847);
const _df8a79648c5d = _5acb85038af6(_71ca17694847);
if (_71ca17694847.classList.contains('\x63\u0075\x73\u0074\u006f\x6d\u002d\u0062\u0075\x79\x2d\u006e\x6f\x77')) {
const _51490146e79f =
_71ca17694847.closest('\x66\u006f\u0072\u006d') ||
document.querySelector('\u0066\x6f\x72\x6d\x5b\u0061\u0063\x74\x69\u006f\u006e\x2a\x3d\x22\u002f\x63\x61\x72\u0074\x2f\u0061\u0064\u0064\u0022\x5d');
if (!_51490146e79f) {
throw new Error('\x50\x72\x6f\x64\x75\x63\x74\x20\x66\x6f\u0072\x6d\x20\u006e\u006f\x74\x20\x66\x6f\x75\x6e\x64');
}
const _d1d21db7fe5d =
_51490146e79f.querySelector('\x2e\u0070\x72\u006f\u0064\u0075\x63\x74\x2d\x76\x61\u0072\u0069\x61\u006e\u0074\u002d\u0069\x64') ||
_51490146e79f.querySelector('\x5b\x6e\u0061\u006d\x65\x3d\x22\u0069\u0064\u0022\u005d');
if (!_d1d21db7fe5d || !_d1d21db7fe5d.value) {
throw new Error('\x56\x61\u0072\u0069\x61\x6e\x74\u0020\x49\x44\u0020\x6e\u006f\x74\x20\x66\u006f\x75\u006e\u0064');
}
const _89f076d05581 = _51490146e79f.querySelector('\x5b\u006e\x61\u006d\u0065\x3d\x22\u0071\x75\x61\x6e\x74\x69\x74\u0079\x22\u005d');
const _e6ef8ce00ff4 = Number(_d1d21db7fe5d.value);
const _a2b79711c52c = _89f076d05581
? Math.max(1, parseInt(_89f076d05581.value || '\x31', 10))
: 1;
const _912ea2e2c8c4 = _71ca17694847.closest('\x70\x72\x6f\x64\x75\u0063\u0074\x2d\u0066\x6f\u0072\x6d\u002d\x63\x6f\u006d\u0070\x6f\u006e\x65\u006e\u0074');
const _38fb523b3942 =
(_912ea2e2c8c4 && _912ea2e2c8c4.dataset.productUrl) ||
window.location.pathname;
const _db62c5ea10c9 =
_38fb523b3942.replace(/\/$/, '') + '\u002e\x6a\x73';
const _911b9f688610 = await fetch(_db62c5ea10c9, {
method: '\x47\u0045\u0054',
credentials: '\u0073\x61\u006d\x65\u002d\x6f\u0072\u0069\x67\u0069\x6e',
headers: {
Accept: '\u0061\u0070\x70\x6c\u0069\x63\x61\x74\x69\u006f\x6e\x2f\u006a\x73\x6f\x6e'
}
});
if (!_911b9f688610.ok) {
throw new Error('\u0070\u0072\u006f\x64\u0075\x63\x74\u0020\u002e\x6a\x73\x20\x66\x61\u0069\x6c\x65\x64');
}
const _9caaaee76cca = await _911b9f688610.json();
const _5e63447b6031 =
(_9caaaee76cca.variants || []).find(function (_f73f207344b4) {
return Number(_f73f207344b4.id) === _e6ef8ce00ff4;
}) ||
(_9caaaee76cca.variants || [])[0] ||
{};
const _69ba732569af = Number(_5e63447b6031.price || _9caaaee76cca.price || 0);
const _eb13043c305e = _69ba732569af / 100;
const _b896f6d40e7e =
_9caaaee76cca.featured_image ||
(Array.isArray(_9caaaee76cca.images) && _9caaaee76cca.images.length
? _9caaaee76cca.images[0]
: '');
const _46f24f77823b = {
storeName: _8a6fa6071b2b,
store_name: _8a6fa6071b2b,
shop_name: _8a6fa6071b2b,
shop_domain: _bf94ce12e6be,
shop_myshopify_domain: _df8a79648c5d,
cart_token: '',
currency: _20a7a20abb60(null),
item_count: _a2b79711c52c,
subtotal_price: _eb13043c305e * _a2b79711c52c,
total_price: _eb13043c305e * _a2b79711c52c,
shippingPrice: 0,
items: [
{
title: _9caaaee76cca.title || '\x50\x72\u006f\u0064\x75\x63\u0074',
variant: _5e63447b6031.title || '\u0044\x65\x66\u0061\x75\u006c\x74\u0020\x54\x69\u0074\u006c\x65',
quantity: _a2b79711c52c,
price: _eb13043c305e,
image: _b896f6d40e7e,
line_key: '',
variant_id: _e6ef8ce00ff4,
product_id: _9caaaee76cca.id || '',
product_title: _9caaaee76cca.title || '',
variant_title: _5e63447b6031.title || '',
line_price: _eb13043c305e * _a2b79711c52c,
sku: _5e63447b6031.sku || '',
vendor: _9caaaee76cca.vendor || ''
}
]
};
_48fe78c5a73d(_17edaf6413ca, _46f24f77823b);
return;
}
const _a5aaa4296dec =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _dc2bf7f9bca6 = await fetch(_a5aaa4296dec + '\x63\u0061\u0072\u0074\u002e\x6a\u0073', {
method: '\x47\x45\u0054',
credentials: '\u0073\x61\x6d\x65\x2d\u006f\x72\u0069\x67\u0069\u006e',
headers: {
Accept: '\x61\u0070\x70\x6c\u0069\u0063\x61\x74\u0069\u006f\u006e\x2f\u006a\u0073\x6f\x6e'
}
});
if (!_dc2bf7f9bca6.ok) {
const _c3b737fdb9bb = await _dc2bf7f9bca6.text();
throw new Error('\u0063\x61\x72\u0074\u002e\x6a\u0073\u0020\x66\x61\u0069\x6c\u0065\u0064\x3a\u0020' + _c3b737fdb9bb.slice(0, 300));
}
const _26d241ce339e = await _dc2bf7f9bca6.json();
if (!_26d241ce339e || !Array.isArray(_26d241ce339e.items) || _26d241ce339e.items.length === 0) {
throw new Error('\x43\x61\u0072\x74\x20\x69\u0073\x20\x65\x6d\x70\x74\u0079');
}
const _46f24f77823b = {
storeName: _8a6fa6071b2b,
store_name: _8a6fa6071b2b,
shop_name: _8a6fa6071b2b,
shop_domain: _bf94ce12e6be,
shop_myshopify_domain: _df8a79648c5d,
cart_token: _26d241ce339e.token || '',
currency: _20a7a20abb60(_26d241ce339e),
item_count: _26d241ce339e.item_count || 0,
subtotal_price: (_26d241ce339e.items_subtotal_price || 0) / 100,
total_price: (_26d241ce339e.total_price || 0) / 100,
shippingPrice: 0,
items: (_26d241ce339e.items || []).map(function (_3199f06ca1ae) {
return {
title: _3199f06ca1ae.product_title || _3199f06ca1ae.title || '\u0050\x72\x6f\u0064\u0075\u0063\u0074',
variant: _3199f06ca1ae.variant_title || '\x44\x65\x66\u0061\x75\x6c\x74\x20\u0054\u0069\u0074\x6c\x65',
quantity: _3199f06ca1ae.quantity || 1,
price: (_3199f06ca1ae.price || 0) / 100,
image: _3199f06ca1ae.image || '',
line_key: _3199f06ca1ae.key || '',
variant_id: _3199f06ca1ae.id || '',
product_id: _3199f06ca1ae.product_id || '',
product_title: _3199f06ca1ae.product_title || _3199f06ca1ae.title || '',
variant_title: _3199f06ca1ae.variant_title || '',
line_price: (_3199f06ca1ae.line_price || 0) / 100,
sku: _3199f06ca1ae.sku || '',
vendor: _3199f06ca1ae.vendor || ''
};
})
};
_48fe78c5a73d(_17edaf6413ca, _46f24f77823b);
} catch (_f9a18862a85d) {
console.error('\x50\x41\u0059\u0020\x44\x45\u0042\u0055\x47\u003a', _f9a18862a85d);
alert(
'\u8bfb\u53d6\x20\x53\u0068\x6f\u0070\x69\u0066\x79\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_f9a18862a85d && _f9a18862a85d.message ? _f9a18862a85d.message : String(_f9a18862a85d))
);
_71ca17694847.disabled = false;
_71ca17694847.innerText = _15040027cb5c;
}
},
true
);
})();
